export interface SelectedVideosToMerge {
  count: number;
  videos: Map<string, boolean>;
}

export enum VideoSourceType {
  ORGANIZATION_VIDEO = 'ORGANIZATION_VIDEO',
  LESA_VEHICLE = 'LESA_VEHICLE',
  VIDEO = 'VIDEO',
  WHEELS_TV = 'WHEELS_TV',
  VINREEL = 'VINREEL',
}

export interface ISourceType {
  sourceType: VideoSourceType;
  sourceId: number;
}
